import { render } from "./App.vue?vue&type=template&id=bd245a16&bindings={\"colors\":\"data\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script